export enum PaginationType {
  PREV = 'PREV',
  NEXT = 'NEXT',
  FIRST = 'FIRST',
  LAST = 'LAST',
}
